import React from 'react';
import { formatNum } from '../../Helpers/format-phone-number';
import PropTypes from 'prop-types';
import { httpCreateCompany } from '../../Hooks/company/company.post.hooks';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';

const SignupCompanySubmit = ({
  company,
  result,
  setResult,
  setIsOpen,
  user,
  disabled,
  billingAddress,
}) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult('');
    try {
      const { phoneMobile, phoneOffice } = company;
      const companyPhone = await formatNum(phoneOffice);
      const mobilePhone = await formatNum(phoneMobile);
      setResult('Creating company...');
      const newCompany = {
        ...company,
        active: true,
        address: [billingAddress],
        phoneMobile: mobilePhone,
        phoneOffice: companyPhone,
        markedForDeletion: null,
        setForDelete: false,
      };
      const res = await httpCreateCompany(newCompany, user);
      const data = await res.json();
      if (!res.ok) {
        setResult(data.msg || 'Failed to create company');
        throw new Error('Failed to create company');
      } else {
        setResult(data.msg || 'Company created successfully');
      }
      setResult(data.msg || 'Company was created successfully!');
      setIsOpen(true);
    } catch (err) {
      console.error(err);
      setResult('There was an error creating the user or company');
    }
  };

  return (
    <>
      <div className="column">
        <p>{result}</p>
        <PrimaryButtonComponent
          functionName={handleSubmit}
          span="Create Company"
          disabled={disabled}
        />
      </div>
    </>
  );
};

SignupCompanySubmit.propTypes = {
  company: PropTypes.shape({
    phoneMobile: PropTypes.string,
    phoneOffice: PropTypes.string,
  }),
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setResult: PropTypes.func,
  notes: PropTypes.string,
  setIsOpen: PropTypes.func,
  billingAddress: PropTypes.object,
  user: PropTypes.object,
  disabled: PropTypes.bool,
  result: PropTypes.string,
};

export default SignupCompanySubmit;
